import { JSX } from 'react';
import { Button, Heading, Layout, Link, Text } from '../../components/core';
import { getRoute, useNavigate } from '../../routes';
import { HeadingLevel, incrementHeadingLevel } from '../core/Heading';

type NoSelfReferContentProps = {
  showReturnButton?: boolean;
  testIdPrefix?: string;
  headingLevel?: HeadingLevel;
};

export const NoSelfReferContent = ({
  showReturnButton = false,
  testIdPrefix = 'no-self-refer',
  headingLevel = 2,
}: NoSelfReferContentProps): JSX.Element => {
  const navigate = useNavigate();

  const onReturnHomePress = (): void => {
    navigate(getRoute('home', {}));
  };

  return (
    <Layout.VStack space={5}>
      <Heading.h3 level={headingLevel}>Campus referral required</Heading.h3>

      <Text.para>
        To sign up for clinical care with Mantra, you will need a referral from an authorized campus
        staff member.
      </Text.para>

      <Heading.h5 level={incrementHeadingLevel(headingLevel)}>
        Contact your school counseling center, or refer to your institution's mental health
        resources on their website.
      </Heading.h5>

      <Text.para>
        If you need further assistance or believe this is an error,{' '}
        <Link.para bold to="mailto:hi@mantrahealth.com">
          please contact us
        </Link.para>
        .
      </Text.para>

      {showReturnButton && (
        <Button.secondaryLarge
          isLink
          testID={`${testIdPrefix}-return-home-button`}
          onPress={onReturnHomePress}
        >
          Return to Care Hub
        </Button.secondaryLarge>
      )}
    </Layout.VStack>
  );
};
